import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

const DescriptionModal = ({ isOpen, onClose, itemId, description, onSave }) => {
  const [newDescription, setNewDescription] = React.useState(description);

  const handleSave = () => {
    onSave(newDescription);
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 350, // Adjust the width as needed
          bgcolor: 'white',
          border: 'none',
          borderRadius: '5px', // Add rounded corners
          boxShadow: 24,
          p: 4,
          outline: 'none',
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ marginBottom: 2 }}>
          Item Description
        </Typography>
        <TextField
          label="Description"
          multiline
          fullWidth
          value={newDescription}
          onChange={(e) => setNewDescription(e.target.value)}
          variant="outlined"
          sx={{ marginBottom: 2 }}
        />
        <Button onClick={handleSave} variant="contained" color="primary">
          Save
        </Button>
      </Box>
    </Modal>
  );
};

export default DescriptionModal;
